/* @flow */
import * as React from 'react';

const JunkRemoval = props => (
  <svg
    width={100}
    height={91}
    viewBox="0 0 100 91"
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M93.378,18 L8.498,18 C6.014,18 4,20.014 4,22.498 L4,79.378 C4,81.862 6.014,83.876 8.498,83.876 L93.378,83.876 C95.862,83.876 97.876,81.862 97.876,79.378 L97.876,22.498 C97.876,20.014 95.862,18 93.378,18 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M70.07,26.849 C72.916,43.288 72.916,59.727 70.07,76.165 C51.092,78.632 32.112,78.632 13.134,76.165 C10.289,59.727 10.289,43.288 13.134,26.849 C32.112,24.384 51.092,24.384 70.07,26.849 Z"
    />
    <path
      strokeWidth={3}
      d="M70.07,26.849 C51.092,24.384 32.112,24.384 13.134,26.849 C10.289,43.288 10.289,59.727 13.134,76.165 C32.112,78.632 51.092,78.632 70.07,76.165 C72.916,59.727 72.916,43.288 70.07,26.849 Z"
    />
    <path
      strokeWidth={3}
      d="M93.378,18 L8.498,18 C6.014,18 4,20.014 4,22.498 L4,79.378 C4,81.862 6.014,83.876 8.498,83.876 L93.378,83.876 C95.862,83.876 97.876,81.862 97.876,79.378 L97.876,22.498 C97.876,20.014 95.862,18 93.378,18 Z"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#D6D7E0"
      points="16.596 89.252 9 89.252 8 84 17.596 84"
    />
    <polygon strokeWidth={3} points="16.596 89.252 9 89.252 8 84 17.596 84" />
    <path strokeWidth={3} d="M2,89.5 L98,89.5" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#D6D7E0"
      points="93.596 89.252 86 89.252 85 84 94.596 84"
    />
    <polygon strokeWidth={3} points="93.596 89.252 86 89.252 85 84 94.596 84" />
    <polygon strokeWidth={1.5} points="80 76.286 89.688 76.286 89.688 60 80 60" />
    <path
      strokeWidth={1.5}
      d="M89.688,46.844 C89.688,44.169 87.519,42 84.844,42 C82.169,42 80,44.169 80,46.844 C80,49.519 82.169,51.688 84.844,51.688 C87.519,51.688 89.688,49.519 89.688,46.844 Z"
    />
    <path
      strokeWidth={1.5}
      d="M89.688,31.844 C89.688,29.169 87.519,27 84.844,27 C82.169,27 80,29.169 80,31.844 C80,34.519 82.169,36.688 84.844,36.688 C87.519,36.688 89.688,34.519 89.688,31.844 Z"
    />
    <polyline
      strokeWidth={1.5}
      points="47.81 26 47.81 31.919 44 37.855 45.905 42.045 45.905 47.804 51.017 51.733 54.161 42.045 60.358 40.045"
    />
    <polyline
      strokeWidth={1.5}
      points="71.714 45 63.246 46.904 58.801 51.748 51 51.748 54.567 59.243 62.4 62.214 60.341 68.953 63.458 76.095"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      points="55.821 59.495 60.055 51 51 51.546"
    />
    <polyline strokeWidth={1.5} points="27.959 76.143 26.959 70.805 25 70" />
    <path strokeWidth={1.5} d="M60.504,27 L59,29.43" />
    <path strokeWidth={3} d="M54,13.843 L64.819,2" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M66.617,2.309 C66.617,1.034 65.583,0 64.308,0 C63.033,0 62,1.034 62,2.309 C62,3.584 63.033,4.618 64.308,4.618 C65.583,4.618 66.617,3.584 66.617,2.309"
    />
    <path strokeWidth={3} d="M48.819,13.843 L38,2" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M36,2.309 C36,1.034 37.034,0 38.309,0 C39.584,0 40.617,1.034 40.617,2.309 C40.617,3.584 39.584,4.618 38.309,4.618 C37.034,4.618 36,3.584 36,2.309"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M56.814,16.407 C56.814,14.525 54.393,13 51.407,13 C48.421,13 46,14.525 46,16.407"
    />
    <path
      strokeWidth={3}
      d="M56.814,17.407 C56.814,14.973 54.393,13 51.407,13 C48.421,13 46,14.973 46,17.407"
    />
  </svg>
);

export default JunkRemoval;



// WEBPACK FOOTER //
// ./src/assets/images/icons/junk-removal.js